<template>
  <div>
    <MenuQuotation/>
    <Quotation_web_site/>
  </div>
</template>

<script>
import MenuQuotation from "@/components/admin/stock/quotation/header_quotation/MenuQuotation";
import Quotation_web_site from "@/components/admin/stock/quotation/Quotation_web_site";
export default {
  name: "QuotationWebSite",
  components: {
    Quotation_web_site,
    MenuQuotation,
  }
}
</script>

<style scoped>

</style>
